export default __webpack_public_path__ + "static/media/variluxG9-bg-3.f28aac9f.png";